/**
 * @name 上传组件
 */
import base from '../../base';
import Form from './Form';

Form.install = function(Vue) {
  Vue.use(base);
  Vue.component(Form.name, Form);
};

export default Form;
